<template>
  <div class="display-content">
    <Tooltip
      v-if="calculation_details || widget"
      placement="top"
      :options="{ appendTo: (el) => el.parentElement }"
    >
      <template #trigger>
        <a
          v-if="detail_report_url"
          href="#"
          :class="`${comparisonStyle}-value`"
          @click.prevent="redirectToReport"
          >{{ valueDisplay }}</a
        >
        <span v-else :class="`${comparisonStyle}-value`">{{
          valueDisplay
        }}</span>
      </template>
      <template #tooltip>
        <div>
          <slot name="tooltip">{{ calculation_details }}</slot>
        </div>
      </template>
    </Tooltip>
    <div v-else>
      <a
        v-if="detail_report_url"
        href="#"
        :class="`${comparisonStyle}-value`"
        @click.prevent="redirectToReport"
        >{{ valueDisplay }}</a
      >
      <span v-else :class="`${comparisonStyle}-value`">{{ valueDisplay }}</span>
    </div>
    <span :class="[`${comparisonStyle}-delta`, deltaColor]"
      >{{ isFinite(comparisonDelta) ? formatPercent(comparisonDelta) : "--"
      }}<i :class="[`${comparisonStyle}-icon`, deltaIcon, deltaColor]"></i
    ></span>
  </div>
</template>

<script>
import Tooltip from "@/components/Tooltip.vue";
const MILLION_DOLLAR_LENGTH = 9;

export default {
  components: {
    Tooltip
  },
  props: {
    base: {
      type: Object,
      default: null
    },
    comparison: {
      type: Object,
      default: null
    },
    type: {
      type: String,
      default: null
    },
    widget: {
      type: Boolean,
      default: false
    },
    invertColor: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    valueDisplay() {
      const value = this.base ? this.base.value : 0;
      if (this.type === "currency") {
        const rawCents = Math.floor(value);
        const options =
          rawCents.toString().length >= MILLION_DOLLAR_LENGTH
            ? {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
              }
            : {};
        return this.dollars(value, options);
      } else if (this.type === "percentage") {
        return this.formatPercent(value);
      } else {
        return value.toLocaleString("en-us");
      }
    },
    comparisonDelta() {
      if (this.base && this.comparison && this.comparison.value > 0) {
        const difference = this.base.value - this.comparison.value;
        return this.type === "percentage"
          ? difference
          : difference / this.comparison.value;
      }
      return Infinity;
    },
    deltaIcon() {
      if (this.comparisonDelta === 0 || !isFinite(this.comparisonDelta)) {
        return "";
      }
      return this.comparisonDelta > 0 ? "fa fa-arrow-up" : "fa fa-arrow-down";
    },
    comparisonStyle() {
      return this.widget ? "widget" : "table-cell";
    },
    deltaColor() {
      if (this.comparisonDelta === 0 || !isFinite(this.comparisonDelta)) {
        return "";
      }
      if (this.invertColor) {
        return this.comparisonDelta > 0 ? "red" : "green";
      }

      return this.comparisonDelta > 0 ? "green" : "red";
    },
    calculation_details() {
      return this.base ? this.base.calculation_details : "";
    },
    detail_report_url() {
      return this.base ? this.base.detail_report_url : "";
    }
  },
  methods: {
    redirectToReport() {
      const parsedUrl = new URL(this.base.detail_report_url);
      const { pathname, search } = parsedUrl;
      this.$router.push(pathname + search);
    }
  }
};
</script>

<style lang="scss" scoped>
.display-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.table-cell-value {
  font-size: 14px;
}

.table-cell-delta {
  color: #676666;
  font-size: 12px;
}

.table-cell-icon {
  font-size: 10px;
  color: #b1b1b1;
  margin-left: 5px;
}

.widget-value {
  font-size: 25px;
  margin-top: 5px;
  display: block;
  word-break: break-word;
  text-align: center;
}

.widget-delta {
  color: #676666;
  font-size: 14px;
}

.widget-header {
  text-align: center;
}

.widget-icon {
  font-size: 12px;
  color: #b1b1b1;
  margin-left: 5px;
}

.green {
  color: var(--organic-green);
}

.red {
  color: var(--danger-color);
}
</style>
